// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popper-sources {\n  margin-top: 8px;\n  line-height: 0.4;\n  padding: 8px 16px;\n  box-sizing: border-box;\n}\n.popper-sources::before {\n    content: \" \";\n    position: absolute;\n    display: block;\n    transform: translateY(10px);\n    top: -4px;\n    width: 9px;\n    height: 9px;\n    right: 0;\n    left: 0;\n    margin: auto;\n    transform: rotate(45deg);\n    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);\n    background: rgba(255, 255, 255, 0.95);\n}\n", ""]);
// Exports
module.exports = exports;
